import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { FindingVerdictMap } from "../hooks/useReviewerFindingVerdicts";

/** Which surface a reviewer sees the case in. Per-device (localStorage), like
 *  showLowConfidenceFindings — NOT server-persisted, so no /api/user_prefs change. */
export type ReviewerDisplayMode = "inline" | "list";

export const reviewerDisplayModeAtom = atomWithStorage<ReviewerDisplayMode>(
  "reviewerDisplayMode",
  "inline",
  undefined,
  { getOnInit: true },
);

/** Chip-tint bridge: the reviewer's per-finding verdicts keyed by `condition`,
 *  mirrored here so the Tiptap ChipView NodeView can tint itself without prop
 *  drilling or React-context-through-NodeView. Written only in reviewVerdict
 *  mode; reset to {} on exit so reporter chips never inherit stale tints. */
export const reviewerVerdictsAtom = atom<FindingVerdictMap>({});
